module.exports = __webpack_public_path__ + "static/media/new-york-70.fdc728e1.jpg";